import { PropsWithChildren } from 'react';
import { Button, Image, Text } from '@/components/base';
import Icon, { IconName } from '@/components/base/Icon';
import { useOwnSchoolGroupByUserId } from '@/hooks/schoolGroup/useSchoolGroupByUserId';
import { useDisclosure } from '@/hooks/useDisclosure';
import SchoolSideBar from '@/routes/SchoolApp/layout/SchoolSideBar';
import { toClassNames } from '@/utils';

const SchoolLayout = ({ children }: PropsWithChildren) => {
  const { isOpen, onClose, onOpen } = useDisclosure({
    defaultIsOpen: true,
  });
  const { data: schoolGroup } = useOwnSchoolGroupByUserId();

  return (
    <div className="flex min-h-screen min-w-full max-w-[100vw] flex-col bg-gray-50 text-gray-500">
      <div className="fixed top-0 z-[1000] flex h-14 w-full items-center bg-primary-500 px-8 py-2 [html[data-live-session-fullscreen]_&]:hidden">
        <Button
          variant="unstyled"
          className={toClassNames('p-1.5', isOpen && 'rounded-lg bg-primary-400')}
          onClick={() => {
            if (isOpen) {
              onClose();
            } else {
              onOpen();
            }
          }}
        >
          <Icon icon={IconName.Hamburger} className="text-white" />
        </Button>
        <Image src="/assets/images/edsy-logo-white.png" alt="Edsy-logo" className="mx-6 mt-3 h-[30px]" />
        {schoolGroup && (
          <div className="rounded-md bg-primary-600 px-2 py-1">
            <Text className="text-sm text-white">{schoolGroup.name}</Text>
          </div>
        )}
      </div>
      <div className="isolate z-10 mt-[56px] flex flex-row [html[data-live-session-fullscreen]_&]:mt-0">
        <div className="contents [html[data-live-session-fullscreen]_&]:hidden">
          <SchoolSideBar isOpen={isOpen} onClose={onClose} />
          <div className={toClassNames('w-0 flex-shrink-0 transition-all duration-500', isOpen && 'w-64')} />
        </div>

        <div className="flex h-[calc(100vh-56px)] w-full flex-col overflow-x-hidden [html[data-live-session-fullscreen]_&]:h-screen">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SchoolLayout;
